import "./InternalFlexBox_module.css";
const InternalFlexBox_module = {
    internalFlexBox: "internalFlexBox__8cc7d6d62a832846"
};
export { InternalFlexBox_module as default };
